import { BACKEND_URL } from "@/lib/api";
import { submissionRows } from "@/lib/forms";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const Answer = ({ row }) => {
  if (!row.answer) return <span className="italic text-sugar-muted">No answer</span>;
  if (row.kind === "image") {
    const src = row.answer.startsWith("http") ? row.answer : `${BACKEND_URL}${row.answer}`;
    return <a href={src} target="_blank" rel="noreferrer"><img src={src} alt={row.question} className="mt-1 h-40 w-40 rounded-xl border border-sugar-border object-cover" /></a>;
  }
  if (row.kind === "email") return <a href={`mailto:${row.answer}`} className="text-sugar-pink hover:underline">{row.answer}</a>;
  if (row.kind === "tel") return <a href={`tel:${row.answer}`} className="text-sugar-pink hover:underline">{row.answer}</a>;
  return <span className="whitespace-pre-wrap">{row.answer}</span>;
};

export const SubmissionDialog = ({ entry, fields, title, onClose }) => (
  <Dialog open={!!entry} onOpenChange={(o) => { if (!o) onClose(); }}>
    <DialogContent data-testid="admin-submission-dialog" className="max-h-[85vh] overflow-y-auto sm:max-w-lg">
      <DialogHeader>
        <DialogTitle className="font-display text-xl text-sugar-ink">{title}</DialogTitle>
        <DialogDescription>Submitted {entry ? new Date(entry.created_at).toLocaleString() : ""}</DialogDescription>
      </DialogHeader>
      {entry && (
        <dl className="divide-y divide-sugar-border">
          {submissionRows(entry, fields).map((row, i) => (
            <div key={i} data-testid={`admin-submission-row-${i}`} className="py-3">
              <dt className="text-xs font-bold uppercase tracking-wide text-sugar-pink">{row.question}</dt>
              <dd className="mt-1 text-sm text-sugar-ink"><Answer row={row} /></dd>
            </div>
          ))}
        </dl>
      )}
    </DialogContent>
  </Dialog>
);
